import { deleteChat } from "@/apis/chat"
import { useAdvancedInfiniteQuery } from "@/hooks/useAdvancedInfiniteQuery"
import { useRouter } from "@/locales/routing"
import { InfiniteQueryObserverOptions, useMutation } from "@tanstack/react-query"
import { useParams, useSearchParams } from "next/navigation"

export const useDeleteChat = (options: InfiniteQueryObserverOptions, { onSuccess }: any = {}) => {
  const { session_id } = useParams()
  const search = useSearchParams()
  const router = useRouter()

  const deleteChatMutation = useMutation({
    mutationFn: deleteChat
  })

  const { remove } = useAdvancedInfiniteQuery(options)

  const onDeleteChat = (sessionIds) => {
    deleteChatMutation.mutate(
      { session_ids: sessionIds },
      {
        onSuccess(data) {
          if (data.status === 200) {
            sessionIds.forEach(id => remove(item => item.id === id))
            onSuccess && onSuccess(data)

            if (sessionIds.some(item => item.toString() === session_id!.toString())) {
              router.replace(`/chats?${search.toString()}`)
            }

          }
        }
      }

    )
  }

  return {
    onDeleteChat,
    isPending: deleteChatMutation.isPending,

  }
}